import { useContext } from 'react'
import useAppSettingsActions from '../../actions/useAppSettingsActions'
import { AppContext, AppContextType } from '../../AppContext'
import ElectronIPC from '../../services/ElectronIPC'
import { Checkbox } from '@/UIComponents2/Checkbox'

export default function ScreenShareInvertMouseWheelCheckbox() {
    const { state: appState } = useContext(AppContext) as AppContextType

    const { updateAppSettingItem } = useAppSettingsActions()

    const { screenControlWheelDirectionInvert } = appState.appSettings

    const onClick = () => {
        const to = !screenControlWheelDirectionInvert
        updateAppSettingItem('screenControlWheelDirectionInvert', to)

        ElectronIPC.setWindowOptions({ isContentProtectionEnabled: !to })
    }

    return (
        <Checkbox
            checked={screenControlWheelDirectionInvert}
            label="Invert mouse wheel during screen control"
            onChange={onClick}
        />
    )
}
